// How to use: Invoke on page and call
// env.isDev || env.isStaging || env.isProd

export const useEnv = () => {
	const config = useRuntimeConfig()
	const env = config.public.NODE_ENV

	return {
		value: env,
		isDev: env === 'development',
		isStaging: env === 'staging',
		isPreprod: env === 'preprod',
		isProd: env === 'production',
	}
}
